import { GRAY30, SubtitleM } from 'global-styles';
import styled from 'styled-components';

export const ItemTitle = styled(SubtitleM)`
  color: ${GRAY30};
  margin-bottom: 16px;
`;
